import { createTheme, rem } from '@mantine/core';

/**
 * UFLEX School — dizayn tizimi (mobil ilova bilan bir xil zamonaviy uslub).
 * Binafsha brend, Manrope shrift, yumshoq soyalar, katta radiuslar.
 */
/*
 * SHRIFT — Manrope (e'lonlar `src/fonts.css` da, mobil ilova bilan bir xil).
 * Poppins'da KIRILL YO'Q edi: ruscha interfeysda barcha kirill harflari tizim zaxira
 * shriftiga tushib, bitta ekranda ikki xil shrift ko'rinardi.
 *
 * QATOR BALANDLIKLARI qayta ko'rildi: Manrope glif qutisi 1.366em (asc 2132 / desc -600 /
 * gap 0, upm 2000), Poppins'niki 1.50em edi. Ya'ni bir xil `lineHeight` da Manrope
 * KAMROQ joy egallaydi — quyidagi qiymatlar (h1 1.25 ... h5 1.4) Poppins bilan ishlagan
 * bo'lsa, Manrope bilan yanada bo'sh turadi, siqilib qolmaydi. Bosh harf balandligi ham
 * deyarli bir xil (Manrope 0.72em, Poppins 0.70em), shuning uchun sarlavhalar o'lchami
 * o'zgarmaydi va qiymatlarni surish shart emas.
 */
export const theme = createTheme({
  primaryColor: 'brand',
  primaryShade: { light: 6, dark: 5 },
  defaultRadius: 'md',
  cursorType: 'pointer',
  autoContrast: true,
  focusRing: 'auto',
  fontFamily: 'Manrope, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  fontFamilyMonospace: 'ui-monospace, "SF Mono", Menlo, Monaco, monospace',
  headings: {
    fontFamily: 'Manrope, -apple-system, BlinkMacSystemFont, sans-serif',
    fontWeight: '700',
    sizes: {
      h1: { fontSize: rem(30), lineHeight: '1.25' },
      h2: { fontSize: rem(24), lineHeight: '1.3' },
      h3: { fontSize: rem(20), lineHeight: '1.35' },
      h4: { fontSize: rem(17), lineHeight: '1.4' },
      h5: { fontSize: rem(15), lineHeight: '1.4' },
    },
  },

  colors: {
    // Binafsha brend (mobil ilova #6C5CE7 bilan bir xil)
    brand: [
      '#f2f0ff', '#e4e0fb', '#c6bef4', '#a79aee', '#8d7ce9',
      '#7d69e6', '#6C5CE7', '#5b4bd4', '#4c3fb8', '#3f349c',
    ],
  },

  radius: {
    xs: rem(6),
    sm: rem(8),
    md: rem(10),
    lg: rem(16),
    xl: rem(22),
  },

  shadows: {
    xs: '0 1px 2px rgba(91, 75, 212, 0.05), 0 1px 3px rgba(91, 75, 212, 0.06)',
    sm: '0 2px 6px rgba(91, 75, 212, 0.06), 0 6px 16px rgba(91, 75, 212, 0.08)',
    md: '0 6px 16px rgba(91, 75, 212, 0.08), 0 12px 28px rgba(91, 75, 212, 0.10)',
    lg: '0 12px 28px rgba(91, 75, 212, 0.12), 0 22px 48px rgba(91, 75, 212, 0.12)',
    xl: '0 24px 56px rgba(91, 75, 212, 0.16)',
  },

  components: {
    Card: { defaultProps: { radius: 'lg', withBorder: true, shadow: 'xs' } },
    Paper: { defaultProps: { radius: 'lg' } },
    // Tugmalar — app dizayni kabi to'liq yumaloq (pill), qalin shrift
    Button: { defaultProps: { radius: 'xl' }, styles: { root: { fontWeight: 600 } } },
    ActionIcon: { defaultProps: { radius: 'lg' } },
    TextInput: { defaultProps: { radius: 'lg' } },
    PasswordInput: { defaultProps: { radius: 'lg' } },
    Select: { defaultProps: { radius: 'lg', checkIconPosition: 'right' } },
    NumberInput: { defaultProps: { radius: 'lg' } },
    Textarea: { defaultProps: { radius: 'lg' } },
    Modal: { defaultProps: { radius: 'lg', centered: true, overlayProps: { blur: 3, backgroundOpacity: 0.4 } } },
    // Badge — pill (qirrasiz)
    Badge: { defaultProps: { radius: 'xl' }, styles: { root: { fontWeight: 600, textTransform: 'none' } } },
    Menu: { defaultProps: { radius: 'lg', shadow: 'md' } },
    Tooltip: { defaultProps: { radius: 'md', withArrow: true } },
    // Sidebar linklari — yumaloq pill
    NavLink: { defaultProps: { radius: 'lg' } },
    SegmentedControl: { defaultProps: { radius: 'xl' } },
    Chip: { defaultProps: { radius: 'xl' } },
    Tabs: {},
    Table: { defaultProps: { verticalSpacing: 'sm', horizontalSpacing: 'md' } },
  },
});
